/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyGroupingRuleResourceLevel {
    getFixupPrototypeFunction() { return CostAnomalyGroupingRuleResourceLevel.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyGroupingRuleResourceLevel>): CostAnomalyGroupingRuleResourceLevel {
        let obj = Object.assign(new CostAnomalyGroupingRuleResourceLevel(), model);
        CostAnomalyGroupingRuleResourceLevel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyGroupingRuleResourceLevel>): CostAnomalyGroupingRuleResourceLevel {
        if (!model) return null;
        return CostAnomalyGroupingRuleResourceLevel.newInstance(<CostAnomalyGroupingRuleResourceLevel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyGroupingRuleResourceLevel) {
        if (!obj) return;

        models.CostAnomalyGroupingRuleResourceLevel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyGroupingRuleResourceLevel): boolean {
        Object.setPrototypeOf(obj, CostAnomalyGroupingRuleResourceLevel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.billed_cost) {
            for (let val of this.billed_cost) {
                models.CostAnomalyBilledCost.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Product Category
     */
    product_category: string;

    /**
     * Resource Category
     */
    resource_category: string;

    /**
     * Region
     */
    location: string;

    /**
     * Resource ID
     */
    resource_id: string;

    /**
     * Billed cost for the resource
     */
    billed_cost: Array<models.CostAnomalyBilledCost>;

}
